














import {Component, Prop, Vue} from "vue-property-decorator";
@Component
export default class Decimal extends Vue {
    @Prop({required:true}) label!:string;
    @Prop({}) icon!:string;
    @Prop({}) md!:number;
    @Prop({}) value!:string;
    @Prop({default:true}) required!:boolean;
    updateValue (value:string) {
        this.$emit('input', value)
    }
    get getIcon():any{
        if(this.icon){
            return false;
        }
        return this.icon;
    }
}
